// extracted by mini-css-extract-plugin
export var space = "Spacer-module--space--05312";